"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Loading = exports.Label = exports.Button = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var variantStyle = function variantStyle(_ref) {
  var variant = _ref.variant,
      color = _ref.color,
      shadow = _ref.shadow;
  return {
    primary: {
      background: color.brandSecondary.gradient,
      boxShadow: shadow.level['04'],
      color: color.neutral['08'],
      ':hover, :focus': {
        boxShadow: shadow.level['02']
      },
      ':active': {
        transition: '0s',
        background: color.brandSecondary.dark
      }
    },
    secondary: {
      background: color.brandPrimary.gradient,
      boxShadow: shadow.level['04'],
      color: color.neutral['08'],
      ':hover, :focus': {
        boxShadow: shadow.level['02']
      },
      ':active': {
        transition: '0s',
        background: color.brandPrimary.light
      }
    },
    outlined: {
      border: "1px solid ".concat(color.brandPrimary.light),
      color: color.brandPrimary.light,
      ':hover, :focus': {
        backgroundColor: color.brandPrimary.light,
        color: color.neutral['08']
      },
      ':active': {
        backgroundColor: color.brandPrimary.medium,
        color: color.neutral['08']
      }
    },
    'outlined-white': {
      border: "1px solid ".concat(color.neutral['08']),
      color: color.neutral['08'],
      ':hover, :focus': {
        backgroundColor: color.neutral['08'],
        color: color.brandPrimary.light
      },
      ':active': {
        backgroundColor: color.line.medium,
        borderColor: color.line.medium,
        color: color.brandPrimary.light
      }
    },
    text: {
      color: color.brandPrimary.light,
      ':hover, :focus': {
        color: color.brandPrimary.medium
      },
      ':active': {
        color: color.brandPrimary.dark
      }
    },
    'text-white': {
      color: color.neutral['08'],
      ':hover, :focus': {
        color: color.neutral['06']
      }
    },
    'secondary-white': {
      backgroundColor: color.neutral['08'],
      boxShadow: shadow.level['03'],
      color: color.brandPrimary.light,
      ':hover, :focus': {
        boxShadow: shadow.level['02']
      },
      ':active': {
        background: color.line.medium
      }
    }
  }[variant];
};

var Button = _styledComponents["default"].button.withConfig({
  displayName: "Buttonstyle__Button",
  componentId: "mvrjv8-0"
})(function (_ref2) {
  var _extends2;

  var _ref2$theme = _ref2.theme,
      breakpoint = _ref2$theme.breakpoint,
      color = _ref2$theme.color,
      shadow = _ref2$theme.shadow,
      border = _ref2$theme.border,
      spacing = _ref2$theme.spacing,
      font = _ref2$theme.font,
      fullWidth = _ref2.fullWidth,
      small = _ref2.small,
      variant = _ref2.variant,
      loading = _ref2.loading;
  return _extends({
    transition: '0.1s',
    background: 'transparent',
    display: 'inline-block',
    border: 'none',
    borderRadius: border.radius.lg,
    width: fullWidth ? '100%' : 'auto',
    cursor: 'pointer',
    outline: 'none',
    padding: small ? spacing.squish.sm : "".concat(spacing.inline['4xs'], " ").concat(spacing.inline.xs),
    fontFamily: font.family.base,
    fontSize: small ? 12 : 14,
    textAlign: 'center',
    textDecoration: 'none',
    position: 'relative',
    pointerEvents: loading ? 'none' : 'auto',
    minWidth: fullWidth ? 'auto' : '148px'
  }, variantStyle({
    variant: variant,
    color: color,
    shadow: shadow
  }), (_extends2 = {
    svg: {
      fill: 'currentColor',
      width: '1em',
      height: '1em',
      top: '.125em',
      position: 'relative'
    }
  }, _defineProperty(_extends2, breakpoint.md(), {
    fontSize: small ? 14 : 16
  }), _defineProperty(_extends2, ':disabled', {
    pointerEvents: 'none',
    opacity: '0.5'
  }), _extends2));
});

exports.Button = Button;

var Label = _styledComponents["default"].span.withConfig({
  displayName: "Buttonstyle__Label",
  componentId: "mvrjv8-1"
})(function (_ref3) {
  var hide = _ref3.hide;
  return {
    color: hide && 'transparent'
  };
});

exports.Label = Label;
var wave = (0, _styledComponents.keyframes)(["from{opacity:0.4;}to{opacity:1;}"]);

var marginBefore = function marginBefore(theme) {
  return "-".concat(theme.spacing.inline['6xs'], " -").concat(theme.spacing.inline['2xs']);
};

var margin = function margin(theme) {
  return "-".concat(theme.spacing.inline['6xs'], " -").concat(theme.spacing.inline['6xs']);
};

var marginAfter = function marginAfter(theme) {
  return "-".concat(theme.spacing.inline['6xs'], " ").concat(theme.spacing.inline['4xs']);
}; // Made with template literals because Keyframes don't work with object syntax


var Loading = _styledComponents["default"].span.withConfig({
  displayName: "Buttonstyle__Loading",
  componentId: "mvrjv8-2"
})(["span,span:before,span:after{background:currentColor;border-radius:50%;width:", ";height:", ";position:absolute;top:50%;left:50%;}span:before{content:'';margin:", ";animation:", " 0.5s 0s linear infinite alternate-reverse;}span{margin:", ";animation:", " 0.5s 0.2s linear infinite alternate-reverse;}span:after{content:'';margin:", ";animation:", " 0.5s 0.4s linear infinite alternate-reverse;}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.spacing.inline['5xs'];
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.spacing.inline['5xs'];
}, function (_ref6) {
  var theme = _ref6.theme;
  return marginBefore(theme);
}, wave, function (_ref7) {
  var theme = _ref7.theme;
  return margin(theme);
}, wave, function (_ref8) {
  var theme = _ref8.theme;
  return marginAfter(theme);
}, wave);

exports.Loading = Loading;